'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Ruler = function Ruler(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 19 21' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'g',
        { fill: 'none', fillRule: 'evenodd' },
        _react2.default.createElement('path', { d: 'M17.23 3.116v2.046h-4.899V3.116c0-.64.558-1.2 1.2-1.2h2.499c.662 0 1.2.538 1.2 1.2zm0 11.345h-1.95V9.308h-1v5.153H12.33V6.162h4.899v8.299zm-2.45 4.908l-2.013-3.908h4.027L14.78 19.37zM16.03.916l-2.5.001c-1.176 0-2.2 1.025-2.199 2.2v11.995l3.449 5.671 3.45-5.67V3.116c0-1.213-.987-2.199-2.2-2.2z',
          fill: 'currentColor' }),
        _react2.default.createElement('path', { d: 'M6.5 1.5v18H3.01A2.5 2.5 0 0 1 .5 17V4c0-1.38 1.125-2.5 2.51-2.5H6.5z', stroke: 'currentColor' }),
        _react2.default.createElement('path', { fill: 'currentColor', d: 'M5.091 2.839H7v1H5.091zM5.091 6.516H7v1H5.091zM3.182 4.677H7v1H3.182zM3.182 8.355H7v1H3.182zM5.091 10.194H7v1H5.091zM3.182 12.032H7v1H3.182zM5.091 13.871H7v1H5.091zM3.182 15.71H7v1H3.182zM5.091 17.548H7v1H5.091z'
        })
      )
    )
  );
};
/*eslint-enable */

exports.default = Ruler;
//# sourceMappingURL=Ruler.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Ruler.js